import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { theme } from '../../theme'
import { TransactionMetric } from '../../models/analytics'
import { useFormatMessage } from '../../helpers/intl'

interface props {
  data: TransactionMetric[]
}

export const RevenueGraph: React.FC<props> = ({ data }) => (
  <ResponsiveContainer minHeight={500} minWidth={290}>
    <BarChart data={data} margin={{ left: -10, top: 0, bottom: 0 }}>
      <XAxis dataKey="humanizeTimestamp" stroke={theme.colors.primary} fontSize={'0.75em'} />

      <YAxis
        yAxisId="left"
        orientation="left"
        stroke={theme.colors.primary}
        allowDecimals={false}
        tickFormatter={(tick) => `$${tick}`}
        fontSize={'0.75em'}
      />
      <Tooltip
        isAnimationActive={false}
        formatter={(value: number) => {
          return `$${value.toFixed(2)}`
        }}
      />
      <Legend />

      <CartesianGrid stroke={theme.colors.ternary300} strokeDasharray="7 7" />

      <Bar
        name={useFormatMessage('dashboard.homePage.revenue', 'Revenue')}
        dataKey="revenue"
        fill={theme.colors.primary}
        yAxisId="left"
      />
    </BarChart>
  </ResponsiveContainer>
)
